import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer id="footer" className="footer">
      <p>
        🎧 Made with love by <strong>SIRIN Alpha</strong>
      </p>
    </footer>
  );
};

export default Footer;
